import {
  UpNextDataModel,
  UpNextDataResponse,
  UpNextItemActionDataModel,
  UpNextItemActionDataResponse,
  UpNextItemDueSoonDataModel,
  UpNextItemDueSoonDataResponse,
  UpNextItemModel,
  UpNextItemResponse,
  UpNextModel,
  UpNextResponse,
} from 'types';

import { normalizeAction } from './action';
import { normalizeCard } from './card';

export const normalizeUpNextData = (
  upNextData: UpNextDataResponse,
  { update = false } = {},
): UpNextDataModel => {
  return {
    card: normalizeCard(upNextData.card),
  };
};

export const normalizeUpNextItemActionData = (
  upNextItemData: UpNextItemActionDataResponse,
  { update = false } = {},
): UpNextItemActionDataModel => {
  return {
    action: normalizeAction(upNextItemData.action),
  };
};

export const normalizeUpNextItemDueSoonData = (
  upNextItemData: UpNextItemDueSoonDataResponse,
  { update = false } = {},
): UpNextItemDueSoonDataModel => {
  return {};
};

export const normalizeUpNextItem = (
  upNextItem: UpNextItemResponse,
  { update = false } = {},
): UpNextItemModel => {
  if (upNextItem.type === 'dueSoon') {
    return {
      data: normalizeUpNextItemDueSoonData(upNextItem.data),
      id: upNextItem.id,
      pos: upNextItem.pos,
      type: upNextItem.type,
    };
  } else {
    return {
      data: normalizeUpNextItemActionData(upNextItem.data),
      id: upNextItem.id,
      pos: upNextItem.pos,
      type: upNextItem.type,
    };
  }
};

export const normalizeUpNext = (
  upNext: UpNextResponse,
  { update = false } = {},
): UpNextModel => {
  return {
    data: normalizeUpNextData(upNext.data),
    id: upNext.id,
    items: upNext.items.map((item) => normalizeUpNextItem(item)),
    pos: upNext.pos,
    type: upNext.type,
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/up-next.ts